import { render } from "./EditSupernaturalMapModal.vue?vue&type=template&id=b5a3d72e&scoped=true"
import script from "./EditSupernaturalMapModal.vue?vue&type=script&lang=js"
export * from "./EditSupernaturalMapModal.vue?vue&type=script&lang=js"

import "./EditSupernaturalMapModal.vue?vue&type=style&index=0&id=b5a3d72e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a3d72e"]])

export default __exports__